import { ExternalService } from 'models/ExternalService';
import { Model } from 'react3l-common';
import { Field } from 'react3l-decorators';

export class ExternalServiceApi extends Model {
    @Field(Number)
    public id?: number;

    @Field(String)
    public url?: string;

    @Field(String)
    public name?: string;

    @Field(Number)
    public externalServiceId?: number;

    @Field(Number)
    public apiAuthenticationConfigurationId?: number;
    
    @Field(String)
    public httpRequestMethod?: string;

    @Field(Number)
    public statusId?: number;

    @Field(Number)
    public timeOut?: number;

    public externalService?: ExternalService;

}
